import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 60 * 60 * 1000,
			gcTime: 24 * 60 * 60 * 1000,
			retry: 1,
			refetchOnWindowFocus: false,
			refetchOnReconnect: true,
			refetchOnMount: true,
		},
		mutations: {
			retry: 0,
		},
	},
});
